<script setup>
import {  defineModel } from "vue";

import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

defineProps({
  onAddItem: {
    type: Function,
    required: true,
  },
  onRemoveItem: {
    type: Function,
    required: true,
  },
})

const InvoiceItems = defineModel([
  {
    Id: "0",
    ProductName: "",
    Quantity: "1",
    UnitPrice: "0",
    
  }
])
</script>
<template>
  <div>
      <div class="row">
        <div class="col-md-6"> <label for="example-text-input" class="form-control-label">ProductName</label> </div>
        <div class="col-md-1"> <label for="example-text-input" class="form-control-label">Quantity</label> </div>
        <div class="col-md-2"> <label for="example-text-input" class="form-control-label">UnitPrice</label> </div>
        <div class="col-md-3"> <label for="example-text-input" class="form-control-label">Action</label> </div>
      </div>
      <div class="row" v-for="Item in InvoiceItems" :key="Item.Id">
        <div class="col-md-6">
          <argon-input type="text" v-model="Item.ProductName" placeholder="ProductName ..." />
        </div>
        <div class="col-md-1">
          <argon-input type="text" v-model="Item.Quantity" placeholder="Quantity ..."/>
        </div>
        <div class="col-md-2">
          <argon-input type="text" v-model="Item.UnitPrice" placeholder="UnitPrice ..."/>
        </div>
        <div class="col-md-3">
          <argon-button class="btn btn-icon btn-3 btn-danger" type="button" @click="onRemoveItem(Item.Id)">
            <span class="btn-inner--text">delete</span>
          </argon-button>
        </div>
      </div>
      <argon-button class="btn btn-icon btn-3 btn-success" type="button" @click="onAddItem">
            <span class="btn-inner--text">add<i class="ni ni-fat-add"></i></span>
          </argon-button>
  </div>
</template>
